import { render, staticRenderFns } from "./MValidasi.vue?vue&type=template&id=c35da1be&scoped=true&lang=html&"
import script from "./MValidasi.vue?vue&type=script&lang=js&"
export * from "./MValidasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35da1be",
  null
  
)

export default component.exports